<div [style.marginTop]="marginTop + 'rem'" [style.marginBottom]="marginBottom + 'rem'">
  @if (showDivider) {
    <p-divider type="solid"> </p-divider>
  }
  <div [class]="titleSize + ' ' + fontWeight">
    {{ props.label }}
    @if (props.required) {
      <span class="text-red-500">*</span>
    }
  </div>

  @if (props.description) {
    <div class="text-sm text-surface-600 dark:text-surface-200 mt-1">
      {{ props.description }}
    </div>
  }
</div>
